"use client";
import React, { useCallback, useMemo, useRef } from "react";
import useEmblaCarousel from "embla-carousel-react";
import AutoScroll from "embla-carousel-auto-scroll";

// Image paths (make sure these exist in /public)
const bgShapes = {
  servicesBg: "/assets/images/shapes/services-bg-1-1.png",
  cityInfoBg: "/assets/images/shapes/cityride-info-bg-1-1.png",
  serviceElement: "/assets/images/shapes/service-element.png",
  cityInfoImg: "/images/bookingg.png",
};

const services = [
  {
    id: 1,
    image: "/images/gallery/3.jpg",
    iconClass: "fa-solid fa-car-side",
    title: "City <br> Transport",
    link: "/services",
    wowDelay: "200ms",
  },
  {
    id: 2,
    image: "/images/gallery/6.jpg",
    iconClass: "fa-solid fa-briefcase",
    title: "Business <br> Tour",
    link: "/services",
    wowDelay: "300ms",
  },
  {
    id: 3,
    image: "/images/gallery/8.jpg",
    iconClass: "fa-solid fa-plane-departure",
    title: "Airport <br> Transport",
    link: "/services",
    wowDelay: "400ms",
  },
];

export default function ServicesSection() {
  const autoScroll = useRef(
    AutoScroll({
      playOnInit: true,
      speed: 1.0,
      stopOnInteraction: false,
      stopOnMouseEnter: false,
    })
  );

  const options = useMemo(
    () => ({
      loop: true,
      align: "start",
      dragFree: true,
      containScroll: "trimSnaps",
      duration: 30,
    }),
    []
  );

  const [emblaRef, emblaApi] = useEmblaCarousel(options, [autoScroll.current]);

  const scrollPrev = useCallback(
    () => emblaApi && emblaApi.scrollPrev(),
    [emblaApi]
  );
  const scrollNext = useCallback(
    () => emblaApi && emblaApi.scrollNext(),
    [emblaApi]
  );

  return (
    <section className="services-one section-space" id="services">
      <div
        className="services-one__bg"
        style={{ backgroundImage: `url(${bgShapes.servicesBg})` }}
      />
      <div className="container">
        {/* ===== WHY CHOOSE US SECTION ===== */}
        <div className="cityride-info">
          <div className="cityride-info__inner">
            <div
              className="cityride-info__bg"
              style={{ backgroundImage: `url(${bgShapes.cityInfoBg})` }}
            />
            <div className="cityride-info__row row text-center align-items-center">
              <div className="col-lg-4 col-sm-6 mb-4">
                <div className="cityride-info__item">
                  <div className="cityride-info__item__icon">
                    <i className="fas fa-bolt"></i>
                  </div>
                  <h4 className="cityride-info__item__title">
                    Easier &amp; Faster <br /> Bookings
                  </h4>
                </div>
              </div>

              <div className="col-lg-4 col-sm-6 mb-4">
                <div className="cityride-info__item">
                  <div className="cityride-info__item__icon">
                    <i className="fas fa-map-marked-alt"></i>
                  </div>
                  <h4 className="cityride-info__item__title">
                    Too Many Pickup <br /> Locations
                  </h4>
                </div>
              </div>

              <div className="col-lg-4 col-sm-6 mb-4">
                <div className="cityride-info__item">
                  <div className="cityride-info__item__icon">
                    <i className="fas fa-smile-beam"></i>
                  </div>
                  <h4 className="cityride-info__item__title">
                    Customers 100% <br /> Satisfied
                  </h4>
                </div>
              </div>
            </div>

            <img
              src={bgShapes.cityInfoImg}
              alt="info"
              className="cityride-info__image"
            />
          </div>
        </div>
      </div>

      {/* ===== SERVICES SLIDER SECTION ===== */}
      <div className="container">
        <div className="services-one__top">
          <div className="row gutter-y-50 align-items-center">
            <div className="col-md-8">
              <div className="sec-title">
                <div
                  className="sec-title__top wow fadeInUp"
                  data-wow-duration="1500ms"
                  data-wow-delay="150ms"
                >
                  <div className="sec-title__shape"></div>
                  <h6 className="sec-title__tagline">our services</h6>
                </div>
                <h3
                  className="sec-title__title wow fadeInUp"
                  data-wow-duration="1500ms"
                  data-wow-delay="200ms"
                >
                  We're Partner Of <br /> Your Business
                </h3>
              </div>
            </div>

            <div className="col-md-4 text-end">
              <div className="services-one__custome-navs">
                <button
                  type="button"
                  className="embla-btn embla-btn--prev"
                  onClick={scrollPrev}
                  aria-label="Previous"
                >
                  <span className="fas fa-arrow-left"></span>
                </button>
                <button
                  type="button"
                  className="embla-btn embla-btn--next"
                  onClick={scrollNext}
                  aria-label="Next"
                >
                  <span className="fas fa-arrow-right"></span>
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* Embla Auto Scroll Slider */}
        <div className="services-embla">
          <div className="services-embla__viewport" ref={emblaRef}>
            <div className="services-embla__container">
              {services.map((s) => (
                <div className="services-embla__slide item" key={s.id}>
                  <div
                    className="service-card wow fadeInUp"
                    data-wow-duration="1500ms"
                    data-wow-delay={s.wowDelay}
                  >
                    <div className="service-card__image">
                      <img src={s.image} alt={s.title} />
                    </div>
                    <div className="service-card__middle">
                      <div className="service-card__icon">
                        <div className="service-card__icon__inner">
                          <i className={s.iconClass}></i>
                        </div>
                        <h3
                          className="service-card__title"
                          dangerouslySetInnerHTML={{
                            __html: `<a href="${s.link}">${s.title}</a>`,
                          }}
                        />
                      </div>
                      <div className="service-card__middle__element">
                        <img src={bgShapes.serviceElement} alt="" />
                      </div>
                    </div>
                    <div className="service-card__btn">
                      <a href={s.link} className="service-card__link">
                        Explore More <i className="fas fa-arrow-right"></i>
                      </a>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      <div className="services-one__inner-bg"></div>
    </section>
  );
}
